export const ADMIN_RESOURCES_SETTING_KEY = 'admin_resources_enabled';
export const ADMIN_RESOURCES_DISABLED_KEY = 'admin_resources_disabled';
export const ADMIN_RESOURCES_ROUTE_NAME = 'admin-resources';
export const ADMIN_RESOURCES_PATH = '/admin/resources';

function isDisabledValue(value: unknown): boolean {
  return value === false || value === 'false' || value === 0 || value === '0';
}

function isEnabledValue(value: unknown): boolean {
  return value === true || value === 'true' || value === 1 || value === '1';
}

/**
 * Administrative Git resource management is on unless the API sends an
 * explicit false-like value. Missing or invalid values fail open.
 */
export function isAdminResourcesEnabled(value: unknown): boolean {
  if (value === undefined || value === null || value === '') {
    return true;
  }

  if (isDisabledValue(value)) {
    return false;
  }

  if (isEnabledValue(value)) {
    return true;
  }

  return true;
}

export function isAdminResourcesRoute(to: { name?: unknown; path?: string } | null | undefined): boolean {
  if (!to) {
    return false;
  }

  if (to.name === ADMIN_RESOURCES_ROUTE_NAME) {
    return true;
  }

  const path = to.path || '';
  return /(^|\/)admin\/resources(\/|$)/.test(path);
}

export function normalizeAdminResourcesEnabledValue(value: unknown): boolean {
  return isAdminResourcesEnabled(value);
}
